const paramDefinitions = (synth) => [
{

	}
]

export default paramDefinitions;
